export default {"src":"/_next/static/media/ic_right_arrow_footer.e7e55511.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};